// import React, { useState, useEffect } from 'react';

// const CreditCardCalculator = () => {
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [expenses, setExpenses] = useState([]);
//   const [summary, setSummary] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     fetchExpenses();
//   }, []);

//   const fetchExpenses = async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/credit-card/expense`);
//       if (response.ok) {
//         const data = await response.json();
//         setExpenses(data);
//       } else {
//         throw new Error('Failed to fetch expenses');
//       }
//     } catch (error) {
//       console.error('Error fetching expenses:', error);
//       setError('Failed to fetch expense data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateSummary = () => {
//     const filteredExpenses = expenses.filter(expense => {
//       const expenseDate = new Date(expense['Date (UTC)']);
//       const start = new Date(startDate);
//       const end = new Date(endDate);
//       return expense.Checked === 'Yes' && 
//              expenseDate >= start && 
//              expenseDate <= end;
//     });

//     const summary = {};

//     filteredExpenses.forEach(expense => {
//       const bankType = expense['Bank Type'];
//       const amount = parseFloat(expense.Amount);
//       const defaultPayment = JSON.parse(expense['Default Payment'] || '{}');

//       if (!summary[bankType]) {
//         summary[bankType] = {};
//       }

//       Object.entries(defaultPayment).forEach(([grant, percentage]) => {
//         if (!summary[bankType][grant]) {
//           summary[bankType][grant] = 0;
//         }
//         summary[bankType][grant] += (amount * parseFloat(percentage) / 100);
//       });
//     });

//     setSummary(summary);
//   };

//   return (
//     <div className="max-w-4xl mx-auto mt-6 p-6 bg-white rounded-lg shadow-lg">
//       <h2 className="text-2xl font-bold mb-6">Credit Card Expense Calculator</h2>
      
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//         <div>
//           <label className="block text-sm font-medium mb-1" htmlFor="startDate">
//             Start Date
//           </label>
//           <input
//             id="startDate"
//             type="date"
//             className="w-full px-3 py-2 border rounded-md"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//           />
//         </div>
//         <div>
//           <label className="block text-sm font-medium mb-1" htmlFor="endDate">
//             End Date
//           </label>
//           <input
//             id="endDate"
//             type="date"
//             className="w-full px-3 py-2 border rounded-md"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//           />
//         </div>
//       </div>
      
//       <button 
//         onClick={calculateSummary}
//         disabled={!startDate || !endDate || loading}
//         className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 mb-6"
//       >
//         {loading ? 'Loading...' : 'Calculate'}
//       </button>

//       {error && (
//         <div className="text-red-500 mb-4">
//           {error}
//         </div>
//       )}

//       {Object.keys(summary).length > 0 && (
//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="bg-gray-50">
//                 <th className="px-4 py-2 text-left border">Bank Type</th>
//                 <th className="px-4 py-2 text-left border">Grant</th>
//                 <th className="px-4 py-2 text-right border">Amount ($)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {Object.entries(summary).map(([bankType, grants]) => 
//                 Object.entries(grants).map(([grant, amount], index) => (
//                   <tr key={`${bankType}-${grant}`} className="hover:bg-gray-50">
//                     {index === 0 ? (
//                       <td className="px-4 py-2 border font-medium" rowSpan={Object.keys(grants).length}>
//                         {bankType}
//                       </td>
//                     ) : null}
//                     <td className="px-4 py-2 border">{grant}</td>
//                     <td className="px-4 py-2 border text-right">{amount.toFixed(2)}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CreditCardCalculator;
import React, { useState, useEffect } from 'react';

const CreditCardCalculator = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [expenses, setExpenses] = useState([]);
  const [deposits, setDeposits] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError('');
      
      const [expenseResponse, depositResponse] = await Promise.all([
        fetch(`${process.env.REACT_APP_BACKEND_API_URL}/credit-card/expense`),
        fetch(`${process.env.REACT_APP_BACKEND_API_URL}/credit-card/deposits`)
      ]);

      if (!expenseResponse.ok || !depositResponse.ok) {
        throw new Error('Failed to fetch data');
      }

      const expenseData = await expenseResponse.json();
      const depositData = await depositResponse.json();
      
      setExpenses(expenseData);
      setDeposits(depositData);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const parseDefaultPayment = (defaultPaymentStr) => {
    try {
      return JSON.parse(defaultPaymentStr || '{}');
    } catch (e) {
      console.error('Error parsing Default Payment:', e);
      return {};
    }
  };

  const calculateSummary = () => {
    const summaryData = {};

    // Initialize summary structure
    const initializeSummaryForBank = (bankType) => {
      if (!summaryData[bankType]) {
        summaryData[bankType] = {
          expenses: {},
          deposits: {},
          net: {}
        };
      }
    };

    // Process expenses
    expenses
      .filter(expense => {
        const expenseDate = new Date(expense['Date (UTC)']);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return expenseDate >= start && 
               expenseDate <= end && 
               expense.Paid === 'No';
      })
      .forEach(expense => {
        const bankType = expense['Bank Type'];
        const amount = parseFloat(expense.Amount) || 0;
        const defaultPayment = parseDefaultPayment(expense['Default Payment']);

        initializeSummaryForBank(bankType);

        Object.entries(defaultPayment).forEach(([grant, percentage]) => {
          const grantAmount = amount * (parseFloat(percentage) / 100);
          
          if (!summaryData[bankType].expenses[grant]) {
            summaryData[bankType].expenses[grant] = 0;
          }
          summaryData[bankType].expenses[grant] += grantAmount;
        });
      });

    // Process deposits
    deposits
      .filter(deposit => {
        const depositDate = new Date(deposit['Date (UTC)']);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return depositDate >= start && 
               depositDate <= end && 
               deposit.Paid === 'No';
      })
      .forEach(deposit => {
        const bankType = deposit['Bank Type'];
        const amount = Math.abs(parseFloat(deposit.Amount)) || 0;
        const defaultPayment = parseDefaultPayment(deposit['Default Payment']);

        initializeSummaryForBank(bankType);

        Object.entries(defaultPayment).forEach(([grant, percentage]) => {
          const grantAmount = amount * (parseFloat(percentage) / 100);
          
          if (!summaryData[bankType].deposits[grant]) {
            summaryData[bankType].deposits[grant] = 0;
          }
          summaryData[bankType].deposits[grant] += grantAmount;
        });
      });

    // Calculate net amounts
    Object.keys(summaryData).forEach(bankType => {
      const allGrants = new Set([
        ...Object.keys(summaryData[bankType].expenses),
        ...Object.keys(summaryData[bankType].deposits)
      ]);

      allGrants.forEach(grant => {
        const expenses = summaryData[bankType].expenses[grant] || 0;
        const deposits = summaryData[bankType].deposits[grant] || 0;
        summaryData[bankType].net[grant] = expenses - deposits;
      });
    });

    setSummary(summaryData);
  };

  const downloadCSV = () => {
    const csvRows = [
      ['Bank Type', 'Grant', 'Expenses ($)', 'Deposits ($)', 'Net Unpaid Amount ($)']
    ];

    Object.entries(summary).forEach(([bankType, data]) => {
      const grants = new Set([
        ...Object.keys(data.expenses),
        ...Object.keys(data.deposits)
      ]);

      grants.forEach(grant => {
        const expenses = data.expenses[grant] || 0;
        const deposits = data.deposits[grant] || 0;
        const net = data.net[grant] || 0;

        csvRows.push([
          bankType,
          grant,
          expenses.toFixed(2),
          deposits.toFixed(2),
          net.toFixed(2)
        ]);
      });
    });

    const csvContent = csvRows
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `net_unpaid_expenses_${startDate}_to_${endDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="max-w-4xl mx-auto mt-6 p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6">Net Unpaid Credit Card Expense Calculator</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="startDate">
            Start Date
          </label>
          <input
            id="startDate"
            type="date"
            className="w-full px-3 py-2 border rounded-md"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="endDate">
            End Date
          </label>
          <input
            id="endDate"
            type="date"
            className="w-full px-3 py-2 border rounded-md"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
      
      <div className="flex gap-4 mb-6">
        <button 
          onClick={calculateSummary}
          disabled={!startDate || !endDate || loading}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300"
        >
          {loading ? 'Loading...' : 'Calculate Net Unpaid Expenses'}
        </button>

        {Object.keys(summary).length > 0 && (
          <button 
            onClick={downloadCSV}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
          >
            Download CSV
          </button>
        )}
      </div>

      {error && (
        <div className="text-red-500 mb-4">
          {error}
        </div>
      )}

      {Object.keys(summary).length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-2 text-left border">Bank Type</th>
                <th className="px-4 py-2 text-left border">Grant</th>
                <th className="px-4 py-2 text-right border">Expenses ($)</th>
                <th className="px-4 py-2 text-right border">Deposits ($)</th>
                <th className="px-4 py-2 text-right border">Net Unpaid Amount ($)</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(summary).map(([bankType, data]) => {
                const grants = new Set([
                  ...Object.keys(data.expenses),
                  ...Object.keys(data.deposits)
                ]);
                
                return Array.from(grants).map((grant, index) => (
                  <tr key={`${bankType}-${grant}`} className="hover:bg-gray-50">
                    {index === 0 ? (
                      <td className="px-4 py-2 border font-medium" rowSpan={grants.size}>
                        {bankType}
                      </td>
                    ) : null}
                    <td className="px-4 py-2 border">{grant}</td>
                    <td className="px-4 py-2 border text-right">
                      {(data.expenses[grant] || 0).toFixed(2)}
                    </td>
                    <td className="px-4 py-2 border text-right">
                      {(data.deposits[grant] || 0).toFixed(2)}
                    </td>
                    <td className="px-4 py-2 border text-right">
                      {(data.net[grant] || 0).toFixed(2)}
                    </td>
                  </tr>
                ));
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CreditCardCalculator;